/* =================================================================
   RANI MOBILYA — Cart Custom JS
   Cart sayfasında (/cart):
   - İndirim kodu uygulama / kaldırma (entegrasyon.rani.com.tr min tutar API)
   - Reload yapmadan Shopify Section Rendering API ile cart footer'ı günceller
   - Sipariş notu + vergi yazısını sol kolona taşır
   ================================================================= */
(function () {
  'use strict';

  var API_URL = 'https://entegrasyon.rani.com.tr/api/shopify/discount-check';
  var SECTION_KEY = 'cart-footer';        // cart.json içindeki section key
  var SECTION_DOM_ID = 'main-cart-footer'; // liquid'deki <div id="main-cart-footer">

  function $msg(container) {
    return container ? container.querySelector('[data-rani-indirim-message]') : null;
  }
  function showMessage(container, text, kind) {
    var msg = $msg(container);
    if (!msg) return;
    msg.textContent = text || '';
    msg.dataset.kind = kind || '';
  }

  function getCartTotalTL(container) {
    var hidden = container.querySelector('[data-rani-cart-total]');
    var cents = hidden ? parseInt(hidden.getAttribute('value') || '0', 10) : 0;
    return cents / 100;
  }

  /**
   * Vergi/kargo yazısını sağ kart sütunundan çıkarıp sol kolonun altına taşır.
   * (Sipariş notu CSS ile tamamen gizleniyor — taşımıyoruz.)
   */
  function relocateOrderNoteToLeft() {
    var leftWrapper = document.querySelector('#main-cart-items .wt-cart');
    if (!leftWrapper) return;

    var holderId = 'rani-cart-extras';
    var holder = document.getElementById(holderId);
    if (!holder) {
      holder = document.createElement('div');
      holder.id = holderId;
      holder.className = 'rani-cart-extras';
      leftWrapper.appendChild(holder);
    }

    // Vergi/kargo yazısı KULLANILMIYOR — DOM'dan kaldır (taşıma değil silme)
    var subtitles = document.querySelectorAll('#main-cart-footer .wt-cart__subtitle');
    subtitles.forEach(function (s) {
      if (s.classList.contains('wt-cart__note__trigger')) return;
      if (s.closest('.wt-cart__note__wrapper')) return;
      s.remove();
    });
  }

  /* ===== Rani Modal sistemi (native <dialog>) ===== */
  function openModal(id) {
    var dlg = document.getElementById(id);
    if (dlg && typeof dlg.showModal === 'function') {
      dlg.showModal();
    } else if (dlg) {
      dlg.setAttribute('open', '');
    }
    document.body.classList.add('rani-modal-open');

    // Taksit modal'ı açılırsa API'yi çağır
    if (id === 'rani-modal-taksit') {
      loadTaksit();
    }
  }
  function closeModal(dlg) {
    if (!dlg) return;
    if (typeof dlg.close === 'function') {
      dlg.close();
    } else {
      dlg.removeAttribute('open');
    }
    document.body.classList.remove('rani-modal-open');
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function loadTaksit() {
    var content = document.querySelector('[data-rani-taksit-content]');
    if (!content) return;
    var cents = parseInt(content.getAttribute('data-cart-total') || '0', 10);
    var totalTL = cents / 100;
    content.innerHTML = '<p class="rani-taksit-loading">Yükleniyor...</p>';
    fetch('https://entegrasyon.rani.com.tr/api/craftgate/installments?tutar=' + encodeURIComponent(totalTL))
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        // API'nin gönderdiği <style>/<script> tag'lerini temizle
        doc.querySelectorAll('style, script, link').forEach(function (el) { el.remove(); });

        // Her banka kartını bul
        var cards = doc.querySelectorAll('.taksitKartAna');
        if (cards.length === 0) {
          // Fallback: API farklı bir yapı gönderdiyse ham HTML göster
          content.innerHTML = doc.body ? doc.body.innerHTML : html;
          return;
        }

        var output = '';
        cards.forEach(function (card) {
          var logo = card.querySelector('img');
          var logoSrc = logo ? (logo.getAttribute('src') || '') : '';
          var logoAlt = logo ? (logo.getAttribute('alt') || 'Banka') : 'Banka';

          var sayilar = card.querySelectorAll('.taksitSayisi');
          var tutarlar = card.querySelectorAll('.taksitTutari');
          var toplamlar = card.querySelectorAll('.taksitToplam');

          var maxLen = Math.max(sayilar.length, tutarlar.length, toplamlar.length);
          if (maxLen === 0) return;

          var rowsHtml = '';
          for (var i = 0; i < maxLen; i++) {
            var sayi = sayilar[i] ? sayilar[i].textContent.trim() : '';
            var tutar = tutarlar[i] ? tutarlar[i].textContent.trim() : '';
            var toplam = toplamlar[i] ? toplamlar[i].textContent.trim() : '';
            if (i === 0) {
              rowsHtml += '<thead><tr>' +
                '<th>' + escapeHtml(sayi) + '</th>' +
                '<th>' + escapeHtml(tutar) + '</th>' +
                '<th>' + escapeHtml(toplam) + '</th>' +
                '</tr></thead><tbody>';
            } else {
              rowsHtml += '<tr>' +
                '<td>' + escapeHtml(sayi) + '</td>' +
                '<td>' + escapeHtml(tutar) + '</td>' +
                '<td>' + escapeHtml(toplam) + '</td>' +
                '</tr>';
            }
          }
          rowsHtml += '</tbody>';

          output += '<div class="rani-taksit-card">' +
            '<div class="rani-taksit-card__header">' +
              (logoSrc ? '<img src="' + escapeHtml(logoSrc) + '" alt="' + escapeHtml(logoAlt) + '" loading="lazy">' : '<span>' + escapeHtml(logoAlt) + '</span>') +
            '</div>' +
            '<table class="rani-taksit-table">' + rowsHtml + '</table>' +
            '</div>';
        });

        content.innerHTML = output;
      })
      .catch(function (err) {
        console.error('Rani taksit:', err);
        content.innerHTML = '<p class="rani-taksit-error">Taksit bilgileri şu an alınamadı. Lütfen daha sonra tekrar deneyiniz.</p>';
      });
  }

  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-rani-modal-open]');
    if (openBtn) {
      openModal(openBtn.getAttribute('data-rani-modal-open'));
      return;
    }
    var closeBtn = e.target.closest('[data-rani-modal-close]');
    if (closeBtn) {
      closeModal(closeBtn.closest('dialog'));
      return;
    }
    // Backdrop click ile kapat
    if (e.target.matches('dialog.rani-modal')) {
      closeModal(e.target);
    }
  });

  /**
   * Sadece cart-footer section'ını yeniler — başarısız olursa fallback reload.
   */
  function refreshCartSection() {
    var current = document.getElementById(SECTION_DOM_ID);
    if (!current) {
      window.location.reload();
      return Promise.resolve();
    }
    // Mevcut sayfa path'ini kullan (çoklu dil/Markets için en güvenli)
    var refreshUrl = window.location.pathname + '?sections=' + SECTION_KEY;
    return fetch(refreshUrl, { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(function (data) {
        if (!data || !data[SECTION_KEY]) {
          console.warn('Rani: section data missing, fallback reload');
          window.location.reload();
          return;
        }
        var parser = new DOMParser();
        var newDoc = parser.parseFromString(data[SECTION_KEY], 'text/html');
        var newSection = newDoc.getElementById(SECTION_DOM_ID);
        if (newSection && current) {
          current.innerHTML = newSection.innerHTML;
          relocateOrderNoteToLeft();
        } else {
          console.warn('Rani: new section element not found, fallback reload');
          window.location.reload();
        }
      })
      .catch(function (err) {
        console.error('Rani section refresh failed, fallback reload:', err);
        window.location.reload();
      });
  }

  function setLoading(container, loading) {
    var btn = container.querySelector('[data-rani-indirim-apply]');
    if (btn) btn.disabled = !!loading;
    container.dataset.loading = loading ? '1' : '0';
  }

  function applyDiscount(container) {
    var input = container.querySelector('[data-rani-indirim-input]');
    if (!input) return;
    var code = (input.value || '').trim();
    if (!code) {
      showMessage(container, 'Lütfen indirim kodunu giriniz.', 'error');
      return;
    }

    var total = getCartTotalTL(container);
    setLoading(container, true);
    showMessage(container, 'Kontrol ediliyor...', 'info');

    fetch(API_URL + '?tutar=' + encodeURIComponent(total) + '&indirim_kodu=' + encodeURIComponent(code))
      .then(function (r) { return r.text(); })
      .then(function (resp) {
        var threshold = parseInt(String(resp).trim(), 10);
        if (threshold === 3000) {
          showMessage(container, 'Sepet tutarınız minimum 3.000 TL olmalıdır.', 'error');
          setLoading(container, false);
          return null;
        }
        if (threshold === 5000) {
          showMessage(container, 'Sepet tutarınız minimum 5.000 TL olmalıdır.', 'error');
          setLoading(container, false);
          return null;
        }
        if (threshold !== 0) {
          showMessage(container, 'İndirim kodu uygulanamadı.', 'error');
          setLoading(container, false);
          return null;
        }

        var form = new FormData();
        form.append('discount', code);
        return fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          body: form
        })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            if (data.discount_codes && data.discount_codes[0] && data.discount_codes[0].applicable === false) {
              showMessage(container, 'Girmiş olduğunuz indirim kodu geçersizdir.', 'error');
              setLoading(container, false);
              return;
            }
            return refreshCartSection().then(function () {
              setLoading(container, false);
            });
          });
      })
      .catch(function (err) {
        console.error('Rani indirim:', err);
        showMessage(container, 'Bir hata oluştu. Lütfen tekrar deneyiniz.', 'error');
        setLoading(container, false);
      });
  }

  function removeDiscount(container) {
    setLoading(container, true);
    var form = new FormData();
    form.append('discount', '');
    fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      body: form
    })
      .then(function (r) { return r.json(); })
      .then(function () { return refreshCartSection(); })
      .then(function () { setLoading(container, false); })
      .catch(function (err) {
        console.error('Rani indirim sil:', err);
        setLoading(container, false);
      });
  }

  document.addEventListener('click', function (e) {
    var applyBtn = e.target.closest('[data-rani-indirim-apply]');
    if (applyBtn) {
      var c1 = applyBtn.closest('[data-rani-indirim]');
      if (c1) applyDiscount(c1);
      return;
    }
    var removeBtn = e.target.closest('[data-rani-indirim-remove]');
    if (removeBtn) {
      var c2 = removeBtn.closest('[data-rani-indirim]');
      if (c2) removeDiscount(c2);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    if (!e.target.matches('[data-rani-indirim-input]')) return;
    e.preventDefault();
    var container = e.target.closest('[data-rani-indirim]');
    if (container) applyDiscount(container);
  });

  // Page load: subtitle'ı sol kolona taşı
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', relocateOrderNoteToLeft);
  } else {
    relocateOrderNoteToLeft();
  }
})();
